var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.student_person_id !== null)?_c('section',[_c('DataKardex',{attrs:{"student_person_id":_vm.student_person_id,"isAdmin":false}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }